
import { mapState, mapGetters } from 'vuex';
import mixins from 'vue-typed-mixins';

import NotificationBanner from '@/components/blocks/notification-banner.vue';
import { formatNumber } from '@/i18n';
import PaginationControl from '@/components/controls/pagination.vue';
import EmailsFilterForm from '@/components/forms/emails-filter.vue';
import tableViewMixin from '@/components/mixins/table-view';
import TableListSkeleton from '@/components/skeletons/table-list.vue';
import { SendGridEmailType } from '@/store/modules/sendgrid_emails/types';

export default mixins(tableViewMixin).extend({
  name: 'EmailsView',
  components: {
    NotificationBanner,
    PaginationControl,
    EmailsFilterForm,
    TableListSkeleton,
  },
  data() {
    return {
      sort: 'last_event_time',
    };
  },
  computed: {
    ...mapState('sendgrid_emails', ['list', 'listPagination', 'summary']),
    ...mapGetters('sendgrid_emails', ['isLoading', 'isLoaded', 'isEmpty']),
    totalItems(): string {
      if (this.isLoaded) {
        return formatNumber(this.listPagination.total);
      }

      return '0';
    },
    summaryStats(): { label: string; value: number; rate: number | null }[] {
      if (!this.summary) {
        return [];
      }

      return [
        { label: this.$t('Sends'), value: this.summary.sends, rate: null },
        { label: this.$t('Delivered'), value: this.summary.delivered, rate: this.summary.deliveredRate },
        { label: this.$t('Unique Opens'), value: this.summary.uniqueOpens, rate: this.summary.openRate },
        { label: this.$t('Unique Clicks'), value: this.summary.uniqueClicks, rate: this.summary.clickRate },
      ];
    },
  },
  methods: {
    typeLabel(type: SendGridEmailType): string {
      const labels: Record<string, string> = {
        [SendGridEmailType.Welcome]: this.$t('Welcome'),
        [SendGridEmailType.WelcomeSimple]: this.$t('Welcome (Simple)'),
        [SendGridEmailType.NewDevice]: this.$t('New Device'),
        [SendGridEmailType.Other]: this.$t('Other'),
      };

      return labels[type] || type;
    },
    statusLabel(status: string): string {
      const labels: Record<string, string> = {
        delivered: this.$t('Delivered'),
        not_delivered: this.$t('Not Delivered'),
        processing: this.$t('Processing'),
      };

      return labels[status] || status || '—';
    },
  },
});
